<template>
  <div>
    <form  @submit.prevent="submit">
      <div class="row justify-content-center">
        <div class="col-sm-9 p-2" style="font-size:12px;">
          <div class="shadow p-3 rounded-lg">
          <!-- INPUT -->
          <div class="sm-form">
            <input
              type="text"
              id="id"
              name="id"
              class="form-control form-control-sm"
              placeholder="id"
              v-model="vdata.id"
              disabled
            />
          </div>
            <div class="sm-form ">
                <label for="title">Title Service</label>
                <input type="text" id="title" name="title" class="form-control form-control-sm" placeholder="title" v-model="vdata.title" >
            </div>
            <p class="mt-2">Icon : </p>
            <a href="https://www.s-ings.com/typicons/" target="__blank">https://www.s-ings.com/typicons/</a>
            <!-- <v-select :options="icons" v-model="vdata.icon" ></v-select> -->
            <select class='form-control' v-model="vdata.icon">
            <option v-for="(item, index) in icons" :key="index+'icons'">{{item}}</option>
            </select>
            <span class="typcn text-5xl" :class="`${vdata.icon}`"></span>
            <div class="sm-form ">
            <p class="">Detail Service</p>
            <textarea type="text" id="detail" name="detail" rows="2" placeholder="detail..." class="form-control md-textarea" v-model="vdata.detail"
            ></textarea>
            </div>
            <div class="sm-form ">
                <label for="style">style</label>
                <input type="text" id="style" name="style" class="form-control form-control-sm" placeholder="style" v-model="vdata.style" >
            </div>
           <div class="sm-form ">
              <label for="urutan">urutan</label>
              <input type="number" id="urutan" name="urutan" class="form-control form-control-sm" placeholder="urutan" v-model="vdata.urutan" >
          </div>
     
          <!-- END INPUT -->
          <!-- BUTTON PART -->
          <div class="mt-3 p-3">
            <button
              type="submit"
              class="btn btn-sm"
              :class="
                btn == 'tambah'
                  ? 'btn-primary'
                  : btn == 'update'
                  ? 'btn-success'
                  : 'btn-danger'
              "
            >
              <span class="typcn typcn-info"></span> Proses  {{ btn }}
            </button>
            <div class="float-right">
              <button
                type="button"
                v-show="btn!='tambah'"
                @click="
                  btn = 'tambah';
                  vdata = {};
                "
                class="btn btn-sm btn-dark"
              >
                <span class="typcn typcn-edit"></span> Tambah
              </button>
              <button
                type="button"
                @click="btn = 'delete'"
                v-show="btn!='tambah'"
                class="ml-3 btn btn-sm btn-danger"
              >
                <span class="typcn typcn-delete"></span> Delete
              </button>
            </div>
          </div>
          </div>
          <!-- END BUTTON PART -->
        </div>
        <div class="col-sm-9 p-2" style="font-size:12px;">
          <div class="shadow rounded-lg">
            <!-- TABLE PART -->
            <div v-if="datanya.length>0" class="p-2">
             <div class="text-right">
                <vue-json-excel :data="datanya">
                  <button type="button" class="btn btn-sm btn-dark">
                    Export <span class="typcn typcn-chart-area"></span>
                  </button>
                </vue-json-excel>
              </div>
                <Btables :tables="datanya"  :cari="['']" :hide="['service']" @selected="ambil" ref="btable" />
            </div>
            <!-- END TABLE PART -->
         </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/autophp.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
let urlnya ='https://gis.officialapp.my.id'
export default {
  components: {
    Btables,
  },
  data() {
    return {
      selected: false,
      vdata: {},
      btn: "tambah",
      datanya:[],
      icons:["typcn-zoom-outline","typcn-zoom-out-outline","typcn-zoom-out","typcn-zoom-in-outline","typcn-zoom-in","typcn-zoom","typcn-world-outline","typcn-world","typcn-wine","typcn-wi-fi-outline","typcn-wi-fi","typcn-weather-windy-cloudy","typcn-weather-windy","typcn-weather-sunny","typcn-weather-stormy","typcn-weather-snow","typcn-weather-shower","typcn-weather-partly-sunny","typcn-weather-night","typcn-weather-downpour","typcn-weather-cloudy","typcn-waves-outline","typcn-waves","typcn-watch","typcn-warning-outline","typcn-warning","typcn-volume-up","typcn-volume-mute","typcn-volume-down","typcn-volume","typcn-video-outline","typcn-video","typcn-vendor-microsoft","typcn-vendor-apple","typcn-vendor-android","typcn-user-outline","typcn-user-delete-outline","typcn-user-delete","typcn-user-add-outline","typcn-user-add","typcn-user","typcn-upload-outline","typcn-upload","typcn-tree","typcn-trash","typcn-times-outline","typcn-times","typcn-time","typcn-ticket","typcn-tick-outline","typcn-tick","typcn-thumbs-up","typcn-thumbs-ok","typcn-thumbs-down","typcn-thermometer","typcn-th-small-outline","typcn-th-small","typcn-th-menu-outline","typcn-th-menu","typcn-th-list-outline","typcn-th-list","typcn-th-large-outline","typcn-th-large","typcn-tags","typcn-tag","typcn-tabs-outline","typcn-support","typcn-stopwatch","typcn-starburst-outline","typcn-starburst","typcn-star-outline","typcn-star-half-outline","typcn-star-half","typcn-star-full-outline","typcn-star","typcn-spiral","typcn-spanner-outline","typcn-spanner","typcn-sort-numerically-outline","typcn-sort-numerically","typcn-sort-alphabetically-outline","typcn-sort-alphabetically","typcn-social-youtube-circular","typcn-social-youtube","typcn-social-vimeo-circular","typcn-social-vimeo","typcn-social-twitter-circular","typcn-social-twitter","typcn-social-tumbler-circular","typcn-social-tumbler","typcn-social-skype-outline","typcn-social-skype","typcn-social-pinterest-circular","typcn-social-pinterest","typcn-social-linkedin-circular","typcn-social-linkedin","typcn-social-last-fm-circular","typcn-social-last-fm","typcn-social-instagram-circular","typcn-social-instagram","typcn-social-google-plus-circular","typcn-social-google-plus","typcn-social-github-circular","typcn-social-github","typcn-social-flickr-circular","typcn-social-flickr","typcn-social-facebook-circular","typcn-social-facebook","typcn-social-dribbble-circular","typcn-social-dribbble","typcn-social-at-circular","typcn-shopping-cart","typcn-shopping-bag","typcn-scissors-outline","typcn-scissors","typcn-rss-outline","typcn-rss","typcn-refresh-outline","typcn-refresh","typcn-radar-outline","typcn-radar","typcn-puzzle-outline","typcn-puzzle","typcn-printer","typcn-power-outline","typcn-power","typcn-point-of-interest-outline","typcn-point-of-interest","typcn-plus-outline","typcn-plus","typcn-plug","typcn-plane-outline","typcn-plane","typcn-pipette","typcn-pin-outline","typcn-pin","typcn-pi-outline","typcn-pi","typcn-phone-outline","typcn-phone","typcn-pencil","typcn-pen","typcn-notes-outline","typcn-notes","typcn-news","typcn-mortar-board","typcn-minus-outline","typcn-minus","typcn-microphone-outline","typcn-microphone","typcn-messages","typcn-message-typing","typcn-message","typcn-media-stop-outline","typcn-media-stop","typcn-media-rewind-outline","typcn-media-rewind","typcn-media-record-outline","typcn-media-record","typcn-media-play-reverse-outline","typcn-media-play-reverse","typcn-media-play-outline","typcn-media-play","typcn-media-pause-outline","typcn-media-pause","typcn-media-fast-forward-outline","typcn-media-fast-forward","typcn-media-eject-outline","typcn-media-eject","typcn-map","typcn-mail","typcn-lock-open-outline","typcn-lock-open","typcn-lock-closed-outline","typcn-lock-closed","typcn-location-outline","typcn-location-arrow-outline","typcn-location-arrow","typcn-location","typcn-link-outline","typcn-link","typcn-lightbulb","typcn-leaf","typcn-keyboard","typcn-key-outline","typcn-key","typcn-input-checked-outline","typcn-input-checked","typcn-info-outline","typcn-info-large-outline","typcn-info-large","typcn-info","typcn-infinity-outline","typcn-arrow-unsorted","typcn-infinity","typcn-image-outline","typcn-image","typcn-html5","typcn-home-outline","typcn-home","typcn-heart-outline","typcn-heart-half-outline","typcn-heart-full-outline","typcn-heart","typcn-headphones","typcn-group-outline","typcn-group","typcn-globe-outline","typcn-globe","typcn-gift","typcn-folder-open","typcn-folder-delete","typcn-folder-add","typcn-folder","typcn-flow-switch","typcn-flow-parallel","typcn-flow-merge","typcn-flow-children","typcn-flash-outline","typcn-flash","typcn-flag-outline","typcn-flag","typcn-filter","typcn-film","typcn-feather","typcn-eye-outline","typcn-eye","typcn-export-outline","typcn-export","typcn-equals-outline","typcn-equals","typcn-eject-outline","typcn-eject","typcn-edit","typcn-dropbox","typcn-download-outline","typcn-download","typcn-document-text","typcn-document-delete","typcn-document-add","typcn-document","typcn-divide-outline","typcn-divide","typcn-directions","typcn-device-tablet","typcn-device-phone","typcn-device-laptop","typcn-device-desktop","typcn-delete-outline","typcn-delete","typcn-database","typcn-css3","typcn-credit-card","typcn-contacts","typcn-compass","typcn-cog-outline","typcn-cog","typcn-coffee","typcn-code-outline","typcn-code","typcn-cloud-storage-outline","typcn-cloud-storage","typcn-clipboard","typcn-chevron-right-outline","typcn-chevron-right","typcn-chevron-left-outline","typcn-chevron-left","typcn-chart-pie-outline","typcn-chart-pie","typcn-chart-line-outline","typcn-chart-line","typcn-chart-bar-outline","typcn-chart-bar","typcn-chart-area-outline","typcn-chart-area","typcn-cancel-outline","typcn-cancel","typcn-camera-outline","typcn-camera","typcn-calendar-outline","typcn-calendar","typcn-calculator","typcn-business-card","typcn-brush","typcn-briefcase","typcn-bookmark","typcn-book","typcn-bell","typcn-beer","typcn-beaker","typcn-battery-mid","typcn-battery-low","typcn-battery-high","typcn-battery-full","typcn-battery-charge","typcn-backspace-outline","typcn-backspace","typcn-attachment-outline","typcn-attachment","typcn-at","typcn-arrow-up-thick","typcn-arrow-up-outline","typcn-arrow-up","typcn-arrow-unsorted","typcn-arrow-sync-outline","typcn-arrow-sync","typcn-arrow-sorted-up","typcn-arrow-sorted-down","typcn-arrow-shuffle","typcn-arrow-right-thick","typcn-arrow-right-outline","typcn-arrow-right","typcn-arrow-repeat-outline","typcn-arrow-repeat","typcn-arrow-sync-outline","typcn-arrow-sync","typcn-arrow-sorted-up","typcn-arrow-sorted-down","typcn-arrow-shuffle","typcn-arrow-right-thick","typcn-arrow-right-outline","typcn-arrow-right","typcn-arrow-repeat-outline","typcn-arrow-repeat","typcn-arrow-move-outline","typcn-arrow-move","typcn-arrow-minimise-outline","typcn-arrow-minimise","typcn-arrow-maximise-outline","typcn-arrow-maximise","typcn-arrow-loop-outline","typcn-arrow-loop","typcn-arrow-left-thick","typcn-arrow-left-outline","typcn-arrow-left","typcn-arrow-forward-outline","typcn-arrow-forward","typcn-arrow-down-thick","typcn-arrow-down-outline","typcn-arrow-down","typcn-arrow-back-outline","typcn-arrow-back","typcn-archive","typcn-anchor-outline","typcn-anchor","typcn-adjust-contrast","typcn-adjust-brightness",]
    };
  },
    layout:'app_admin',
  methods: {
    getData(){
      sdb.collection("app_portofolio_service",false,urlnya).doc().select(`select * from app_portofolio_service where iduser='${this.$store.state.users.id}'`).then(res => {
        this.datanya=res;
        this.$forceUpdate();
      });
    },
    ambil(data) {
      this.vdata = data;
      this.btn = "update";
      this.$forceUpdate();
    },
    async submit() {
      let that=this
      that.vdata.iduser=this.$store.state.users.id
      if (confirm("Apakah yakin proses dilanjutkan ?")) {
        if (this.btn == "tambah") {
          delete this.vdata.id;
          await sdb
            .collection("app_portofolio_service",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "update") {
         await sdb
            .collection("app_portofolio_service",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "delete") {
          await sdb
            .collection("app_portofolio_service",true,urlnya)
            .doc(this.vdata.id)
            .delete()
              that.getData();
        }
      }
    },
  },
  async mounted() {
          this.getData();
  },
};
</script>